export { default as Pressable } from './Pressable';
export type { IPressableProps } from './types';
